import VeeValidate from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja'
import Vue from 'vue'
import VueHead from 'vue-head'
import Notifications from 'vue-notification'
import VueRouter from 'vue-router'

import Banner from '@/components/atoms/Banner.vue'
import Button from '@/components/atoms/Button.vue'
import Checkbox from '@/components/atoms/Checkbox.vue'
import Input from '@/components/atoms/Input.vue'
import Password from '@/components/atoms/Password.vue'
import Spinner from '@/components/atoms/Spinner.vue'
import '@/components/global'
import DropdownSelect from '@spa/components/atoms/DropdownSelect.vue'
import Link from '@spa/components/atoms/Link.vue'
import Radio from '@spa/components/atoms/Radio.vue'
import SectionBar from '@spa/components/atoms/SectionBar.vue'
import Textarea from '@spa/components/atoms/Textarea.vue'
import DefaultTemplate from '@spa/components/templates/Default.vue'

import App from '@spa/hl-app/components/App.vue'
import router from '@spa/hl-app/router'
import store from '@spa/store'

import { log } from '@spa/log'

import '@/validation/email-compatible-with-old-system'

export async function initHlAppSpa() {
  Vue.use(VueHead)
  Vue.use(VueRouter)

  // TODO: Remove this line, because this is temporary debugging code
  log.debug({ FRONT_ENV: process.env.FRONT_ENV })

  Vue.config.productionTip = false

  Vue.component('spa-default-template', DefaultTemplate)
  Vue.component('spa-input', Input)
  Vue.component('spa-password', Password)
  Vue.component('spa-link', Link)
  Vue.component('spa-banner', Banner)
  Vue.component('spa-button', Button)
  Vue.component('spa-section-bar', SectionBar)
  Vue.component('spa-spinner', Spinner)
  Vue.component('spa-textarea', Textarea)
  Vue.component('spa-radio', Radio)
  Vue.component('spa-checkbox', Checkbox)
  Vue.component('spa-dropdown-select', DropdownSelect)

  VeeValidate.Validator.localize('ja', ja)
  // @ts-ignore
  Vue.use(VeeValidate)
  Vue.use(Notifications)

  // tslint:disable-next-line:no-unused-expression
  new Vue({
    // This css selector SHOULD be specified in MPA template
    el: '#spa-root',
    router,
    store,
    template: '<App/>',
    components: { App },
  })
}
